// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Placeholder_wrapper__3PujW","placeholderImg":"Placeholder_placeholderImg__5frrC","description":"Placeholder_description__1yAV3"};